import { call, put } from 'redux-saga/effects';
import { handleServerError } from 'store/alerts/actions';
import { ensureHttpsForTags } from 'functions/ensureHttpsUrl';
import * as tagActions from '../actions';
import * as tagApi from '../api';

function* fetchTagSimilar({ payload: { id } }) {
  try {
    const response = yield call(tagApi.fetchSimilar, { id });

    const processedTags = ensureHttpsForTags(response.data);

    yield put(tagActions.recieveSimilar(processedTags));
  } catch (error) {
    yield put(handleServerError(error));
  }
}

export default fetchTagSimilar;
